import React from "react";
import emptyDishListBySearch from "../images/emptyDishListBySearch.png";
import { useTranslation } from "react-i18next";

export const EmptyDishListBySearch: React.FC = () => {
    const { t: translate } = useTranslation();

    return (
        <div className="d-flex justify-content-center align-items-center flex-column py-4">
            <img className={"d-block"} src={emptyDishListBySearch} alt="emptyDishListBySearchImg" />
            <h2 className={"fs-24 fw-bold my-3"}>{translate("Nothing seems to be found")}</h2>
            <p className={"mb-0 text-secondary col-12 col-sm-10 col-md-6 col-xl-6 text-center"}>
                {translate("No dishes were found for your request. Adjust your search and try again")}
            </p>
        </div>
    );
};
